<template>
    <div id="contacts">
        <v-container>
        <sectionTitle :title="title" />  
            <div class="text-xs-center">
                <h2>Напишіть Ірині на <a href="https://www.facebook.com/ir.semenenko" target="_blank">Facebook</a></h2>                    
                <div class="fb-comments" data-href="http://irina-semenenko.com/" data-numposts="5"></div>
            </div>
        </v-container>
    </div>
</template>

<script>
    import sectionTitle from "@/components/SectionTitle";
    export default {
         name: 'Contacts',
         components: { sectionTitle },
         data() {
             return {
                title: 'Контакти'
             }
        }
     }
</script>

<style>
    #contacts {
        background-color: #eee!important;
    }
    #contacts h2 {
        font-family: 'Open Sans Condensed', sans-serif!important;
    }
</style>
